import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "antd";
import HomePage from "./pages/home/HomePage";
import IntroductionPage from "./pages/introduction/IntroductionPage";
import ProfilesPage from "./pages/profiles/ProfilesPage";
import CareerSwipeProccessPage from "./pages/careerSwipeProccess/CareerSwipeProccessPage";
import PricePage from "./pages/prices/PricesPage";
import { analytics } from "./firebase/firebaseConfig";
import { logEvent } from "firebase/analytics";
//Component
const JobManager: React.FC = () => {
  useEffect(() => {
    const startTime = Date.now();
    logEvent(analytics, 'sneak_peek_start', { startTime });
    return () => {
      const endTime = Date.now();
      const duration = endTime - startTime;
      logEvent(analytics, 'sneak_peek_end', { endTime, duration });
    };
  }, []);

  return (
    <Routes>
      <Route path="/:lang" element={
        <Layout style={{ height: "100vh", width: "100vw" }}>
          <HomePage />
        </Layout>
      } />

      <Route path="/:lang/introduction" element={
        <Layout style={{ height: "100vh", width: "100vw" }}>
          <IntroductionPage />
        </Layout>
      } />

      <Route path="/:lang/profiles/*" element={
        <Layout style={{ height: "100vh", width: "100vw" }}>
          <ProfilesPage />
        </Layout>
      } />

      <Route path="/:lang/process" element={
        <Layout style={{ height: "100vh", width: "100vw" }}>
          <CareerSwipeProccessPage />
        </Layout>
      } />

      <Route path={"/:lang/prices"} element={
        <Layout style={{ height: "100vh", width: "100vw" }}>
          <PricePage />
        </Layout>
      } />

      <Route
        path="/"
        element={<Navigate to="/:lang" replace />}
      />
    </Routes>
  );
};

export default JobManager;